export default [
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      pageTitle: 'Error',
      layout: 'full',
      resource: 'Auth',
      action: 'read',
      skipFavorites: true,
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/pages/authentication/Login-v2.vue'),
    meta: {
      pageTitle: 'Login',
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
      requiresAuth: false,
      skipFavorites: true,
      redirectWithQuery: true,
      action: 'read',
    },
  },
  {
    path: '/verify-token',
    name: 'verify-token',
    component: () => import('@/views/pages/authentication/VerifyToken-v2.vue'),
    meta: {
      pageTitle: 'Token Authentication',
      layout: 'full',
      resource: 'Auth',
      requiresAuth: false,
      skipFavorites: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'auth-forgot-password',
    component: () => import('@/views/pages/authentication/ForgotPassword-v2.vue'),
    meta: {
      pageTitle: 'Forgot Password',
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
      requiresAuth: false,
      skipFavorites: true,
    },
  },
  {
    path: '/password-verify-token',
    name: 'password-verify-token',
    component: () => import('@/views/pages/authentication/VerifyTokenResetPassword.vue'),
    meta: {
      pageTitle: 'Verify Token',
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
      requiresAuth: false,
      skipFavorites: true,
    },
  },
  {
    path: '/auth/security-question',
    name: 'security-question',
    component: () => import('@/views/pages/authentication/PasswordResetQuestion.vue'),
    meta: {
      pageTitle: 'Password Reset Questions',
      layout: 'full',
      resource: 'Auth',
      requiresAuth: false,
      skipFavorites: true,
    },
  },
  {
    path: '/auth/reset-password',
    name: 'auth-reset-password-v1',
    component: () => import('@/views/pages/authentication/ResetPassword-v2.vue'),
    meta: {
      pageTitle: 'Reset Password',
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
      skipFavorites: true,
    },
  },
  {
    path: '/setup-security-questions',
    name: 'setup-security-questions',
    component: () => import('@/views/pages/authentication/SetUpSecurityQuestions.vue'),
    meta: {
      pageTitle: 'Security Questions',
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
      skipFavorites: true,
    },
  },
  {
    path: '/reset-expired-password',
    name: 'reset-expired-password',
    component: () => import('@/views/pages/authentication/ResetExpiredPassword.vue'),
    meta: {
      pageTitle: 'Reset Expired Password',
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
      skipFavorites: true,
    },
  },
  {
    path: '/verified-system-access',
    name: 'verified-system-access',
    component: () => import('@/views/pages/authentication/VerifyUserSystemAccess-v2.vue'),
    meta: {
      pageTitle: 'Unverified User',
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
      requiresAuth: false,
      skipFavorites: true,
    },
  },
  {
    path: '/create-otp-factor',
    name: 'create-otp-factor',
    component: () => import('@/views/pages/authentication/CreateOTPFactor.vue'),
    meta: {
      pageTitle: 'Create OTP Factor',
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
      requiresAuth: false,
      skipFavorites: true,
    },
  },
  {
    path: '/pages/miscellaneous/coming-soon',
    name: 'misc-coming-soon',
    component: () => import('@/views/pages/miscellaneous/ComingSoon.vue'),
    meta: {
      pageTitle: 'Coming Soon',
      layout: 'full',
      skipFavorites: true,
    },
  },
  {
    path: '/pages/miscellaneous/not-authorized',
    name: 'misc-not-authorized',
    component: () => import('@/views/pages/miscellaneous/NotAuthorized.vue'),
    meta: {
      pageTitle: 'Not Authorized',
      // layout: 'full',
      resource: 'Auth',
      skipFavorites: true,
    },
  },
  {
    path: '/pages/miscellaneous/under-maintenance',
    name: 'misc-under-maintenance',
    component: () => import('@/views/pages/miscellaneous/UnderMaintenance.vue'),
    meta: {
      pageTitle: 'Maintenance',
      layout: 'full',
      skipFavorites: true,
    },
  },
  {
    path: '/pages/miscellaneous/error',
    name: 'misc-error',
    component: () => import('@/views/pages/miscellaneous/Error.vue'),
    meta: {
      layout: 'full',
      skipFavorites: true,
    },
  },
  {
    path: '/pages/account-setting',
    name: 'pages-account-setting',
    component: () => import('@/views/pages/account-setting/AccountSetting.vue'),
    meta: {
      pageTitle: 'Account Settings',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Account Settings',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/profile',
    name: 'pages-profile',
    component: () => import('@/views/pages/profile/Profile.vue'),
    meta: {
      pageTitle: 'Profile',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Profile',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/faq',
    name: 'pages-faq',
    component: () => import('@/views/pages/faq/Faq.vue'),
    meta: {
      pageTitle: 'FAQs',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'FAQ',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/knowledge-base',
    name: 'pages-knowledge-base',
    component: () => import('@/views/pages/Knowledge-base/KnowledgeBase.vue'),
    meta: {
      pageTitle: 'Knowledge Base',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Knowledge Base',
          active: true,
        },
      ],
    },
  },

  // Utilities

  {
    path: '/utilities/api-gateway',
    name: 'api-gateway',
    component: () => import('@/views/pages/utilities-management/ApiGateway.vue'),
    meta: {
      pageTitle: 'API Gateway',
      breadcrumb: [
        {
          text: 'Utilities',
        },
        {
          text: 'API Gateway',
          active: true,
        },
      ],
    },
  },

  // communications
  {
    path: '/communications/email',
    name: 'email',
    component: () => import('@/views/pages/communications-management/Email.vue'),
    meta: {
      pageTitle: 'Email',
      breadcrumb: [
        {
          text: 'Communications',
        },
        {
          text: 'Email',
          active: true,
        },
      ],
    },
  },
  {
    path: '/communications/sms',
    name: 'sms',
    component: () => import('@/views/pages/communications-management/Sms.vue'),
    meta: {
      pageTitle: 'SMS',
      breadcrumb: [
        {
          text: 'Communications',
        },
        {
          text: 'SMS',
          active: true,
        },
      ],
    },
  },
  {
    path: '/channels',
    name: 'channels',
    component: () => import('@/views/pages/channels-management/Channels.vue'),
    meta: {
      pageTitle: 'Channels',
      breadcrumb: [
        {
          text: 'Channels',
        },
        {
          text: 'Channels',
          active: true,
        },
      ],
    },
  },
]
